import 'core-js/stable'; // Polyfills (replaces babel-polyfill)

import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { createRoot } from 'react-dom/client';
import { renderRoutes } from './routes';
import { normalize } from 'csstips';

// Normalize css
normalize();
// Our style overrides
//require('./styles/main.css');
/**
 * Polyfill fetch
 */
import "whatwg-fetch";

document.addEventListener('DOMContentLoaded', () => {
  const root = createRoot(document.getElementById('app')!);
  root.render(renderRoutes());
});
